<template>
    <div class="col-md-12 grid-margin stretch-card">
        <div class="card activeCard">
            <div class="card-body forceLTR">
                <div
                    v-if="isUsePatientInfo"
                    class="d-flex align-items-start justify-content-between pointer forceLTR"
                >
                    <h6
                        v-on:click="GoToPatientContacts"
                        class="card-title flex-grow lower-line text-truncate"
                    >
                        {{ $t('Shared.Title') }}
                    </h6>
                    <i
                        class="mdi mdi-arrow-right-drop-circle text-corporate"
                        v-on:click="GoToPatientContacts"
                    ></i>
                </div>
                <div
                    v-if="!isUsePatientInfo"
                    class="d-flex align-items-start justify-content-between"
                >
                    <h6 class="card-title flex-grow lower-line text-truncate">
                        {{ $t('Shared.Title') }}
                    </h6>
                </div>

                <p v-if="Contacts.length === 0" class="text-muted">
                    {{ $t('MdPatientContactsBox.NoContacts') }}
                </p>

                <div
                    v-for="(contact, index) in Contacts"
                    v-bind:key="`contact-${index}`"
                    v-bind:class="index > 0 ? 'contactItem contactItemBorder' : 'contactItem'"
                >
                    <div class="float-left col-md-12 text-muted p-item">
                        <b>{{ contact.contactName }}</b>
                    </div>
                    <div class="float-left col-md-4 text-muted p-item" v-if="contact.dob">
                        <small>{{ $t('Shared.Dob') }}</small
                        ><br />
                        <b>{{ formatDate(contact.dob) }}</b>
                    </div>
                    <div class="float-left col-md-4 text-muted p-item" v-if="contact.cellPhone">
                        <small>{{ $t('Shared.CellPhone') }}</small
                        ><br />
                        <b
                            ><a :href="'tel:' + contact.cellPhone" class="dashLink dashCell">{{
                                contact.cellPhone
                            }}</a></b
                        >
                    </div>
                    <div class="float-left col-md-4 text-muted p-item" v-if="contact.email">
                        <small>{{ $t('Shared.Email') }}</small
                        ><br />
                        <b
                            ><a :href="'mailto:' + contact.email" class="dashLink dashMail">{{
                                contact.email
                            }}</a></b
                        >
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.portalAccessTranslated"
                    >
                        <small>{{ $t('PPDbContacts.PortalAccess') }}</small
                        ><br />
                        <b :class="{ DocumentExpired: contact.portalAccess }">{{
                            contact.portalAccessTranslated
                        }}</b>
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.contactUserName"
                    >
                        <small>{{ $t('PPDbContacts.ContactUserName') }}</small
                        ><br />
                        <b>{{ contact.contactUserName }}</b>
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.releaseOnFileTranslated"
                    >
                        <small>{{ $t('Shared.ReleaseOnFile') }}</small
                        ><br />
                        <b>{{ contact.releaseOnFileTranslated }}</b>
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.endDateforActiveRelease"
                    >
                        <small>{{ $t('Contact.ActiveReleaseOnFileEndDate') }}</small
                        ><br />
                        <b>{{ formatDate(contact.endDateforActiveRelease) }}</b>
                        <br v-if="contact.activeReleaseExpired" />
                        <span
                            v-if="contact.activeReleaseExpired"
                            class="DocumentExpired DocumentExpiredRed"
                            >{{ $t('Shared.Expired') }}</span
                        >
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.portalNotificationsTranslated"
                    >
                        <small>{{ $t('Shared.PortalNotifications') }}</small
                        ><br />
                        <b>{{ contact.portalNotificationsTranslated }}</b>
                    </div>
                    <div
                        class="float-left col-md-4 text-muted p-item"
                        v-if="contact.appointmentNotificationsTranslated"
                    >
                        <small>{{ $t('PPDbContacts.Appointment') }}</small
                        ><br />
                        <b>{{ contact.appointmentNotificationsTranslated }}</b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContactService from '@/services/contact.service';
import Utils from '@/common/utils';

export default {
    props: {
        PatientCode: String,
        goToPatientContactsButtonVisible: {
            type: Boolean,
            default: undefined
        }
    },
    data() {
        return {
            Contacts: [],
            isUsePatientInfo:
                this.goToPatientContactsButtonVisible !== undefined
                    ? this.goToPatientContactsButtonVisible
                    : this.$store.state.isUsePatientInfo
        };
    },
    methods: {
        formatDate(value) {
            return value ? Utils.formatterDateToString(value) : '';
        },

        async getContacts() {
            const response = await ContactService.getPatientPortalAll({
                PatientCode: this.PatientCode
            });
            if (response.status === 200 && response.data) {
                this.Contacts = response.data;
            }
        },

        GoToPatientContacts() {
            this.$router
                .push({ name: 'patients-portal-contacts', params: { id: this.PatientCode } })
                .catch(() => {});
        }
    },
    mounted() {
        this.getContacts();
    }
};
</script>

<style scoped>
.contactItem {
    overflow: hidden;
    padding-bottom: 10px;
}
.contactItemBorder {
    border-top: 1px solid #e0e0e0;
    padding-top: 10px;
    margin-top: 5px;
}
</style>
